import React, { Fragment, useState } from 'react';
import { Button } from 'rhinostyle';
import { FILE_BASE_URL, SUPPORTED_FILE_TYPES_FOR_PREVIEW } from '../constants/AppConstants';
import { getFileMimeType } from '../helpers/DataHelpers';
import { getAttachmentCategory } from '../helpers/AttachmentHelpers';
import AttachmentViewer from './AttachmentViewer';

export default function LinkedAttachments(props) {
  const { event, breakBeforeFirstAttachment } = props;
  const [activeAttachment, setActiveAttachment] = useState(null);

  const buildAttachmentWithDownloadLink = (attachment) => {
    const { attachmentUrl } = attachment;
    const downloadURL = `${FILE_BASE_URL}${attachmentUrl}`;
    const fileType = attachment.type || getFileMimeType(downloadURL);
    const filename = attachment.name;
    return { downloadURL, fileType, filename, category: getAttachmentCategory(fileType) };
  };

  const filterPreviewableAttachments = (attachment) => !SUPPORTED_FILE_TYPES_FOR_PREVIEW.includes(attachment.fileType);

  const nonPreviewableAttachments = event?.attachments
    ?.map(buildAttachmentWithDownloadLink)
    .filter(filterPreviewableAttachments);
  if (!nonPreviewableAttachments?.length) return null;
  return (
    <>
      { nonPreviewableAttachments?.map((attachment, index) => (
        <Fragment key={attachment.downloadURL}>
          {!(!breakBeforeFirstAttachment && index === 0) && (<br />)}
          {/* Open the unified viewer so video/audio can play and any file can be
              downloaded. The download warning + native-safe anchor live inside the
              viewer (see AttachmentViewer / RHIN-12480). */}
          <Button reset className="convo__linked-attachment" onClick={() => setActiveAttachment(attachment)}>
            {attachment.filename}
          </Button>
        </Fragment>
      ))}
      <AttachmentViewer
        open={!!activeAttachment}
        attachment={activeAttachment}
        onClose={() => setActiveAttachment(null)}
      />
    </>
  );
}
